import React, { useContext } from "react";
import { AppContext } from "../../App";
import Chart from "react-apexcharts";
import { convertAndSortKeys } from "../format/SortMonth";
import { ProcessData } from "../format/ProcessMonthYear";
const ViewChart = () => {
  const { billData } = useContext(AppContext);

  const { totalPaymentSums } = ProcessData(billData);

  // Convert totalPaymentSums object into arrays for ApexViewChart
  const chartData = Object.entries(convertAndSortKeys(totalPaymentSums)).map(
    ([monthYear, totalPaymentSum]) => ({
      x: monthYear,
      y: (totalPaymentSum / 1000 / 1000).toFixed(3),
    })
  );

  const options = {
    chart: {
      height: 330,
      type: "bar",
    },
    plotOptions: {
      bar: {
        borderRadius: 0,
        dataLabels: {
          position: "top", // top, center, bottom
        },
      },
    },
    dataLabels: {
      enabled: true,
      offsetY: -20,
      style: {
        fontSize: "15px",
        colors: ["#304758"],
      },
    },
    xaxis: {
      position: "top",
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        style: {
          fontSize: "15px", // Change the font size here for x-axis
        },
      },
      crosshairs: {
        fill: {
          type: "gradient",
          gradient: {
            colorFrom: "#D8E3F0",
            colorTo: "#BED1E6",
            stops: [0, 100],
            opacityFrom: 0.4,
            opacityTo: 0.5,
          },
        },
      },
      tooltip: {
        enabled: true,
      },
    },
    yaxis: {
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        show: true,
        style: {
          fontSize: "15px", // Change the font size here for y-axis
        },
      },
    },
    title: {
      text: "Total Payments by Month",
      floating: true,
      offsetY: 320,
      align: "center",
      style: {
        color: "#444",
      },
    },
  };

  return (
    <div>
      <Chart
        options={options}
        series={[{ data: chartData }]}
        type="bar"
        height={340}
      />
    </div>
  );
};

export default ViewChart;
